import React, { memo } from 'react';

import { SearchEvent } from '@atlas/components';
import { useSearchContext } from '@atlas/core';
import { EventLink } from '@atlas/routing';

import { useSearch } from 'hooks/useSearch';

const Event = memo(({ event, searchString }) => {
  return (
    <EventLink className="search-link" eventId={event.id}>
      <SearchEvent
        awayName={event.awayName}
        category={event.categoryName}
        highlight={searchString}
        homeName={event.homeName}
        sport={event.sportName}
        tournament={event.tournamentName}
      />
    </EventLink>
  );
});

const SearchEvents = () => {
  const { events } = useSearchContext();
  const { searchString } = useSearch();

  return events.map(event => <Event event={event} key={event.id} searchString={searchString} />);
};

export default SearchEvents;
